import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function ThemeDetail() {
  const { id } = useParams();
  const [theme, setTheme] = useState(null);

  useEffect(() => { api.get(`/themes/${id}`).then(({ data }) => setTheme(data)); }, [id]);

  if (!theme) return <div className="max-w-3xl mx-auto px-6 py-32 text-center text-muted-foreground/75 italic serif text-xl">Unsealing…</div>;

  return (
    <div data-testid="theme-detail" className="max-w-5xl mx-auto px-6 sm:px-10 py-20 reveal">
      <Link to="/themes" className="label link-underline">← Back to Themes</Link>
      <h1 className="mt-10 serif text-5xl sm:text-7xl text-foreground leading-[1.02]">{theme.title}</h1>
      <p className="mt-6 text-xl text-foreground/75 max-w-3xl serif italic font-light">{theme.summary}</p>

      <div className="label mt-20 mb-8">Concepts in this theme</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border">
        {theme.concepts?.map((c) => (
          <Link
            key={c.id}
            to={`/concept/${c.id}`}
            data-testid={`theme-concept-${c.id}`}
            className="bg-card p-8 hover:bg-secondary transition-colors duration-500 group block"
          >
            <span className={`tag tag-${c.source_type}`}>{c.source_type}</span>
            <h3 className="mt-4 serif text-2xl text-foreground group-hover:text-[hsl(var(--primary))] transition-colors">
              {c.title}
            </h3>
            <p className="mt-3 text-muted-foreground text-[14px] leading-relaxed">{c.summary}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
